/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 * @author Evgeniy Naumov
 * @version 1.26.0
 * @since 1.25.1
 */

import styled from 'styled-components';

interface IAttachedItemContainerStyledProps {
    $fullWidth: boolean;
}
export const AttachedItemContainerStyled = styled.li<IAttachedItemContainerStyledProps>`
    width: ${(props) => (props.$fullWidth ? '100%' : 'fit-content')};
    max-width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    & > :last-child {
        margin-left: 24px;
    }
`;
